export enum ERole {
  Admin = 'admin',
  Teacher = 'teacher',
  Student = 'student',
}
